import React from "react";
import { Dialog, Transition } from "@headlessui/react";
import { Fragment } from "react";

import ReactMarkdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

interface InfoModalProps {
    isOpen: boolean;
    onClose: () => void;
    title: string;
    description: string;
}

export const InfoModal: React.FC<InfoModalProps> = ({
    isOpen,
    onClose,
    title,
    description,
}) => {
    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-[100]" onClose={onClose}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black/60 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-md transform overflow-hidden rounded-2xl bg-white dark:bg-neutral-900 p-6 text-left align-middle shadow-xl transition-all border border-transparent dark:border-neutral-800">
                                <Dialog.Title
                                    as="h3"
                                    className="text-lg font-medium leading-6 text-neutral-900 dark:text-neutral-100"
                                >
                                    {title}
                                </Dialog.Title>
                                <div className="mt-4">
                                    <div className="text-sm text-neutral-600 dark:text-neutral-400 prose dark:prose-invert max-w-none prose-sm leading-relaxed">
                                        <ReactMarkdown remarkPlugins={[remarkGfm]}>
                                            {description}
                                        </ReactMarkdown>
                                    </div>
                                </div>

                                <div className="mt-4 flex justify-end">
                                    <button
                                        type="button"
                                        className="inline-flex justify-center rounded-md border border-transparent bg-accent-primary px-4 py-2 text-sm font-medium text-white hover:bg-accent-primary/90 focus:outline-none"
                                        onClick={onClose}
                                    >
                                        Close
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};
